import { render, staticRenderFns } from "./part_editor.vue?vue&type=template&id=5b893fba&scoped=true&"
import script from "./part_editor.vue?vue&type=script&lang=js&"
export * from "./part_editor.vue?vue&type=script&lang=js&"
import style0 from "./part_editor.vue?vue&type=style&index=0&id=5b893fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b893fba",
  null
  
)

export default component.exports